module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMS45OTR2NTEyLjAwMkgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwOUE0OSIgZD0iTTAgMGgxNzAuNjY3djUxMi4wMDJIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNGRjc5MDAiIGQ9Ik0zNDEuMzMzIDBINTEydjUxMi4wMDJIMzQxLjMzM3oiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ie.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ie.svg
// module chunks = 0